import React from 'react';
import './Loading.css'; // Import the CSS file

const LoadingWave = () => (
  <div className="loading-wave-container">
    <div className="wave"></div>
    <div className="wave"></div>
    <div className="wave"></div>
  </div>
);

export default LoadingWave;
